import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { useIntercom } from 'react-use-intercom';
import { Layout } from '../../contexts/LayoutContext';
import LogoSP from './components/Header';
import Form from './components/Form';
import FormDialog from '../Login/components/FormDialog';
import AuthService from '../../services/auth/AuthService';
import ExpiredModal from '../Login/components/ExpiredModal';
import WelcomeModal from './components/WelcomeModal';
import colors from '../../styled/colors';
import mediaQueries from '../../utils/mediaQueries';

const Main = styled.main`
  height: 100vh;
  background: linear-gradient(180deg, #00b4cc 0%, #00a8be 100%);
  padding-top: 58px;
  overflow: scroll;
  @media ${mediaQueries.mdUp} {
    padding-top: 92px;
  }
  @media (max-width: 1366px) and (orientation: landscape) {
    padding-top: 60px;
  }
`;

const TitleContainer = styled.div`
  width: 100%;
  margin-top: 42px;
  margin-bottom: 20px;
  @media ${mediaQueries.mdUp} {
    margin-top: 72px;
    margin-bottom: 42px;
  }
  @media (max-width: 1366px) and (orientation: landscape) {
    margin-top: 36px;
    margin-bottom: 16px;
  }
`;
const Title = styled.h1`
  color: ${colors.white};
  font-size: 26px;
  font-weight: 600;
  text-align: center;
  @media ${mediaQueries.mdUp} {
    font-size: 30px;
  }
`;
const LoginApp = () => {
  const { shutdown } = useIntercom();
  const [open, setOpen] = useState(false);
  const [showModal, setShowModal] = useState(AuthService.getExpiredTimeModal());
  const handleCloseModal = () => {
    AuthService.unsetExpiredTimeModal();
    setShowModal(false);
  };
  useEffect(() => {
    window.setLocationDefault = (currencyCodeIOS, countryCodeIOS) => {
      window.localStorage.setItem('currencyCode', currencyCodeIOS);
      window.localStorage.setItem('countryCode', countryCodeIOS);
    };

    shutdown();
  }, []);

  return (
    <Layout
      title="Login App"
      Header={<></>}
      Footer={<></>}
      disableHeader
      accessOnTrialEnds
    >
      <Main>
        <FormDialog open={open} setOpen={setOpen} />
        <LogoSP background="none" />
        <TitleContainer>
          <Title>
            <FormattedMessage
              id="login.header"
              defaultMessage="Welcome Back!"
            />
          </Title>
        </TitleContainer>
        <Form
          setOpen={setOpen}
          background="none"
          colorLabelInput={colors.white}
        />
      </Main>
      <ExpiredModal
        open={showModal}
        handleClose={() => handleCloseModal()}
      />
      <WelcomeModal />
    </Layout>
  );
};

export default LoginApp;
